import React, { useEffect, useState } from "react";
import { Button } from "antd";
import StoreImage from "../../assets/images/store-game-img.png";
import FeatureImage from "../../assets/images/feature-product-image.png";

import CoinImage from "../../assets/images/header-coin-icon.svg";
import PlusImage from "../../assets/images/plus-image.svg";
import Main from "../../components/layout/Main";

import { Clock, Star } from "lucide-react";
import { useNavigate } from "react-router";
import { useStore } from "../../context/StoreContext";
import { useParams } from "react-router";
import CommonBreadcrumb from "../../components/BreadCrumb";
import { Severty, ShowToast } from "../../helper/toast";
const StoreCategory = () => {
  // --------- Constants -----------
  const navigate = useNavigate();
  const { id } = useParams();
  const [activeMode, setActiveMode] = useState("All");
  const [sortValue, setSortValue] = useState("newest");
  const { loadVendorProducts } = useStore();
  const [store, setStore] = useState({});
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState(["All"]);
  const { addCartItem } = useStore();

  // --------- Handlers -----------

  const fetchProducts = async (categoryFilter = null) => {
    try {
      const params =
        categoryFilter && categoryFilter !== "All"
          ? { category: categoryFilter }
          : {};

      const response = await loadVendorProducts(id, params);
      if (response.success) {
        setStore(response.data.vendorDetail);
        console.log("response", response.data.vendorDetail);
        setProducts(response.data.data);
        // Only set categories on initial load
        if (!categoryFilter) {
          setCategory(["All", ...response.data.categories]);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleAddCartItem = async (id, quantity = 1) => {
    const response = await addCartItem(id, quantity);
    if (response.status === 200) {
      ShowToast(response.message, Severty.SUCCESS);
    } else {
      ShowToast(response.error, Severty.ERROR);
    }
  };

  // --------- Effects -----------
  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <>
      <Main>
        <CommonBreadcrumb
          items={[
            { title: "Home", url: "/home" },
            { title: "Stores", url: "/stores" },
            { title: store?.vendorName || "N/A" },
          ]}
        />
        <section className="for-upcoming-tumanents">
          <div className="store-featured-cate-card store-featured-cate-card_new">
            <div className="store-featured-card-images">
              <img src={store.imageUrl || StoreImage} />
            </div>
            <div className="store-featured-card-details">
              <h6>{store?.vendorName || "N/A"}</h6>
              <p>Computers, Laptops, Mobiles</p>

              <div className="store-gamming-ratting">
                <Star />
                <span>{store?.rating}</span>
              </div>
              <div className="store-gamming-time">
                <Clock /> <span>{store?.Distance}</span>
              </div>
            </div>
          </div>
        </section>
        <section className="for-upcoming-tumanents">
          <div className="game-modes-filter">
            {category.map((mode) => (
              <Button
                key={mode}
                type={activeMode === mode ? "primary" : "default"}
                onClick={() => {
                  setActiveMode(mode);
                  fetchProducts(mode);
                }}
                className="mode-filter-btn"
              >
                {mode}
              </Button>
            ))}
          </div>

          <div className="store-featured-card-main">
            {products.map((product, index) => (
              <div className="feature-product-card">
                <img
                  src={product?.images?.[0] || FeatureImage}
                  onClick={() =>
                    navigate(`/stores/product/${id}/${product._id}`)
                  }
                />
                <div className="feature-text">
                  <div
                    className="feature-text-innerr all-stored-grid"
                    onClick={() =>
                      navigate(`/stores/product/${id}/${product._id}`)
                    }
                  >
                    <h5>{product.name}</h5>
                    <h6>
                      <img src={CoinImage} />{" "}
                      {product?.coins || product.price || 800}
                    </h6>
                    <h6>{product.price} KD</h6>
                  </div>
                  <span
                    className="add-plus-span"
                    onClick={() => {
                      handleAddCartItem(product._id, 1);
                    }}
                  >
                    <img src={PlusImage} />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </section>
      </Main>
    </>
  );
};

export default StoreCategory;
